import React, { useEffect } from 'react'
import { MdOutlineClose } from 'react-icons/md';
import BackButton from '../UI/BackButton';
import Button from '../UI/Button';
import { useState } from 'react';
import { useRef } from 'react';
import { MdAddCircleOutline } from 'react-icons/md';
import { LuFileCheck2 } from 'react-icons/lu';
import { HiOutlineTrash } from 'react-icons/hi2';
import Input from '../UI/Input';
import Select from "react-select";
import AssetTabs from './AssetTabs';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "#f8f6f2"
            : state.isFocused
                ? "#f8f6f2"
                : "white",
        color: state.isSelected ? "white" : "black",
        cursor: "pointer",
    }),
};

const days = 4

const AssetModal = ({ isOpen, index, closeModal, formData, companyDetails, setIsAssetSaved, isAssetSaved, allAssets, setAllAssets, priceName }) => {

    const [assetOptions, setAssetOptions] = useState([])
    const [selectedAssets, setSelectedAssets] = useState([])
    const [assetData, setAssetData] = useState({
        asset_ids: [],
        package: [],
        price_id: null
    });

    console.log("assetData", companyDetails)

    const updateAssets = (assetData) => {
        if (assetData?.asset_ids?.length > 0) {
            const selected = assetData?.asset_ids?.map((assetId) => {
                const asset = companyDetails?.assets?.find((asset) => asset.id === assetId)
                return {
                    value: asset.id,
                    label: asset.name,
                }
            })
            setSelectedAssets(selected)
        }
        if (companyDetails?.assets?.length > 0) {
            const options = companyDetails?.assets?.map((asset) => {
                return {
                    value: asset.id,
                    label: asset.name,
                }
            })
            setAssetOptions(options)
        }
    }

    useEffect(() => {
        console.log("called", assetData)
        if (assetData?.asset_ids?.length > 0) {
            const selected = assetData?.asset_ids?.map((assetId) => {
                const asset = companyDetails?.assets?.find((asset) => asset.id === assetId)
                return {
                    value: asset.id,
                    label: asset.name,
                }
            })
            setSelectedAssets(selected)
        }
        if (companyDetails?.assets?.length > 0) {
            const options = companyDetails?.assets?.map((asset) => {
                return {
                    value: asset.id,
                    label: asset.name,
                }
            })
            setAssetOptions(options)
        }
    }, [companyDetails])

    useEffect(() => {
        const current = allAssets?.find((item) => item.price_id === index)
        if (current) {
            setAssetData(current)
        }
        console.log("current", current)
        updateAssets(current)
    }, [allAssets])

    const handleSelectAssets = (selectedOptions) => {
        console.log(selectedOptions);

        const updated = selectedOptions || [];

        const newAssetIds = updated.map((item) => item.value);

        // Rebuild package while preserving existing data where possible
        const newPackage = updated.map((item) => {
            // Try to find existing asset in the current package
            const existingAsset = assetData.package.find(
                (asset) => asset.asset_id === item.value
            );

            // If exists, preserve it
            if (existingAsset) {
                return existingAsset;
            }

            // Otherwise, create new asset with default structure
            return {
                asset_id: item.value,
                asset_name: item.label,
                inventory: [],
            };
        });

        const updatedAssets = {
            ...assetData,
            asset_ids: newAssetIds,
            package: newPackage,
        };

        console.log(updatedAssets);
        setAssetData(updatedAssets);
        setSelectedAssets(updated);
    };

    if (!isOpen) return null;
    return (
        <div
            class="relative z-20"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"


        >
            <div

                class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                aria-hidden="true"
            ></div>

            <div id="portal" class="fixed inset-0 z-10 w-screen h-[100vh]">
                <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                    <div class="relative max-h-[90vh] overflow-auto w-full transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div class="bg-white rounded-lg px-4 md:px-2 pb-2 pt-5 sm:p-6 sm:pb-4">
                            <div class="flex md:px-4 flex-col gap-4 cursor-pointer">
                                <div className="flex gap-8 items-center justify-between">
                                    <h2 className="text-2xl md:text-3xl font-bold">
                                        Create Package
                                    </h2>
                                    <MdOutlineClose
                                        size={25}
                                        onClick={closeModal}
                                        className=" text-gray-500 cursor-pointer"
                                    />
                                </div>
                                {
                                    priceName && <p>Price Category: <span className='font-semibold'>{priceName}</span></p>
                                }
                                {/* <div className='grid grid-cols-2 gap-x-4'>
                                    <div className="">
                                        <label className="text-sm input_label_padding  font-normal">
                                            Package Name
                                        </label>
                                        <Input
                                            placeholder="Package Name"
                                            type="text"
                                            classes="w-[100%] w-full"
                                            name="attribute"
                                            //  handleChange={handleChange}
                                            required
                                        //  defaultValue={
                                        //    storedFormData?.variablePrices?.length > 0
                                        //      ? storedFormData?.variablePrices[arrayIndex]?.attribute
                                        //      : ""
                                        //  }
                                        />
                                    </div>
                                    <div className="">
                                        <label className="text-sm input_label_padding  font-normal">
                                            Package Price
                                        </label>
                                        <Input
                                            placeholder="Package Price"
                                            type="text"
                                            classes="w-[100%] w-full"
                                            name="attribute"
                                            //  handleChange={handleChange}
                                            required
                                        //  defaultValue={
                                        //    storedFormData?.variablePrices?.length > 0
                                        //      ? storedFormData?.variablePrices[arrayIndex]?.attribute
                                        //      : ""
                                        //  }
                                        />
                                    </div>
                                </div> */}
                                {assetOptions.length > 0 && <div className="col-span-2">
                                    <label className="text-base ml-2  font-normal">
                                        Select Assets
                                    </label>
                                    <Select
                                        onChange={handleSelectAssets}
                                        // ref={instructorRef}
                                        value={selectedAssets}
                                        className='menu-outer-top'
                                        isMulti
                                        isSearchable
                                        options={assetOptions}
                                        menuPosition='fixed'
                                        styles={customStyles}
                                        menuPortalTarget={document.getElementById("portal")}
                                        menuPlacement="bottom"
                                        classNames={{
                                            control: () => "!rounded-xl !border-2 !border-[#e5e7eb]",
                                            // menuPortal: ()=> "!fixed z-20",
                                        }}
                                    />
                                </div>}
                                {selectedAssets.length > 0 && <div>
                                    <AssetTabs days={formData?.number_of_days} assets={companyDetails.assets} assetData={assetData} setAssetData={setAssetData} index={index} />
                                </div>}
                            </div>
                        </div>


                        <hr className="my-2 h-[1px] border-none bg-black opacity-30" />
                        <div className="flex justify-between px-4 py-3">
                            {/* <button
                  type="button"
                  onClick={() => {
                    setChosenFiles([]);
                    closeModal();
                  }}
                  className=" bg-white border-[1px] font-semibold border-black border-opacity-40 px-10 py-1 text-black rounded-lg"
                >
                  Cancel
                </button> */}
                            <BackButton
                                text={"Cancel"}
                                handleClick={() => {
                                    // setChosenFile(null);
                                    closeModal();
                                }}
                            ></BackButton>
                            {/* <button
                  type="button"
                  className="text-white bg-[#4F55DA] font-medium px-10 py-1 my-0 rounded-lg"
                  onClick={() => {
                    setEventImages((prev) => [...prev, ...chosenFiles]);
                    setChosenFiles([]);
                    closeModal();
                  }}
                >
                  Done
                </button> */}
                            <Button text={"Done"}
                                // handleClick={() => {
                                //     // setFormData((prev) => ({ ...prev }));
                                //     // setChosenFile([]);
                                //     const updated = [...isAssetSaved]
                                //     updated.push(index)
                                //     setIsAssetSaved(updated)
                                //     const all = [...allAssets]
                                //     const existing = all.find((item) => item.price_id === index)
                                //     console.log('existing', existing)
                                //     if(existing){
                                //         all.splice(all.indexOf(existing), 1)
                                //     }
                                //     assetData.price_id = index
                                //     console.log("assetData", assetData)
                                //     all.push(assetData)
                                //     console.log('all', all)
                                //     setAllAssets(all)
                                //     closeModal();
                                // }} 
                                handleClick={() => {
                                    // mark as saved
                                    setIsAssetSaved((prev) => [...new Set([...prev, index])]);

                                    // create fresh copy with price_id
                                    const updatedAssetData = {
                                        ...assetData,
                                        price_id: index,
                                    };

                                    setAllAssets((prev) => {
                                        // check if already exists
                                        const exists = prev.some((item) => item.price_id === index);

                                        if (exists) {
                                            // replace in place
                                            return prev.map((item) =>
                                                item.price_id === index ? updatedAssetData : item
                                            );
                                        } else {
                                            // append only if not found
                                            return [...prev, updatedAssetData];
                                        }
                                    });

                                    closeModal();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AssetModal
